import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LegalService {
  /** * Array of legal pages (label/route) */
  public legalPages = [
    {
      label: 'Origence Legal Terms & Privacy Policy',
      route: '/terms-and-policy',
      newWindow: true
    }
    // {
    //   label: 'Origence Legal Terms',
    //   route: '/legal/terms-of-use',
    //   newWindow: true
    // },
    // {
    //   label: 'Privacy Policy',
    //   route: '/legal/privacy-policy',
    //   newWindow: true
    // }
  ];
}
